import {AppState} from '../reducerType';

export const selectWebCbt = (state: AppState): string => state.partner.webcbt;